import type {Project} from '../Project.js'
import {getUnarchiveTime} from './getUnarchiveTime.js'
import dayjs from 'dayjs'

export const canUnarchiveProject = (project: Project): boolean => {
  if (dayjs().isSame(getUnarchiveTime(project))) return true
  if (dayjs().isAfter(getUnarchiveTime(project))) return true
  return false
}
